import { useEffect, useState } from "react";

import { request } from "@/util/request";

const getTotalMember = async (contestNumber: number) => {
  return request<number>(`contest/${contestNumber}/totalMemberNumber`);
};

export const useTotalMemberFetch = () => {
  const [totalMember, setTotalMember] = useState<number>();

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      const response = await getTotalMember(1);
      if (mounted) {
        setTotalMember(response);
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, []);

  return { totalMember };
};
